import { ReactNode } from 'react';
import styled from 'styled-components';

interface StyledDivProps {
  children?: ReactNode;
}

export const Wrapper = styled.div<StyledDivProps>`
  display: flex;

  @media (max-width: 991px) {
    flex-wrap: wrap;
  }
`;

export const ChildrenWrapper = styled.div<StyledDivProps>`
  max-width: calc(100vw - 350px);
  width: 100%;
`;
